import React from 'react';

/**
 * NoSelectionPlaceholder - Displayed when no family is selected
 */
export default function NoSelectionPlaceholder() {
    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: 'var(--text-secondary)', textAlign: 'center', gap: '1rem' }}>
            <i className="fa-solid fa-boxes-stacked" style={{ fontSize: '3.5rem', opacity: 0.3 }}></i>
            <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '0.25rem' }}>No Family Selected</h3>
                <p style={{ fontSize: '0.9rem', margin: 0 }}>Select a family from the left list or create a new one to manage details and feature overrides.</p>
            </div>
        </div>
    );
}
